import * as S from "./style";
//Components
import InputSearch from "../../FieldSearch";
import ActionButton from "../../Button/ActionButton";
import PopMenu from "../../PopMenu";

import CreateCustomer from "../../../components/Modals/Customer/Create";
import CreateAgreements from "../../../components/Modals/Agreements/Create";

import Create from "../../Modals/Frame/Create";
import CreateSupplier from "../../Modals/Supplier/Create";
import CreateBrainds from "../../../components/Modals/Brainds/Create";
import CreateMaterial from "../../Modals/Material/Create";

import CreateLens from "../../Modals/Lens/Create";
import CreateAntiGlare from "../../Modals/AntiGlare/Create";
import CreateSurfacing from "../../../components/Modals/Surfacing/Create";
import CreateDiameter from "../../../components/Modals/Diameter/Create";
import CreateIndice from "../../../components/Modals/Indice/Create";
import CreateHeight from "../../../components/Modals/Height/Create";

import CreateTypeLens from "../../../components/Modals/TypeLens/Create";
import CreateSensitivity from "../../../components/Modals/Sensitivity/Create";
import CreateLaboratory from "../../../components/Modals/Laboratory/Create";

import CreateExpenses from "../../../components/Modals/Expense/Create";
import CreateCategory from "../../../components/Modals/Expense/Category/Create";

//Hooks
import { useMultipleModal } from "../../../hooks/useMultipleModal";
//Icons
import { CaretDown, Export } from "@phosphor-icons/react";
import { ITitle } from "Interfaces/ITitle";

export default function TitleMenu({
  title,
  subtitle,
  placeholderSearch,
  listPopMenu,
  listPopButton,
  fetchData,
  filterSearch,
  exportButton,
  visibleButton = true,
  visibleButtonExport = true
}: ITitle) {
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();

  const handleInputChange = (inputSearch: string) => {
    filterSearch(inputSearch);
  };

  return (
    <S.Container>
      <S.Title>
        <S.H4>{title}</S.H4>
        <S.H6>{subtitle}</S.H6>
      </S.Title>

      <S.ContentSearch>
        <InputSearch name={placeholderSearch} onSearch={handleInputChange} />

        <S.ContentButton>
          {
            visibleButtonExport &&
            <ActionButton
              name="Exportar"
              Icon={<Export size={18} weight="bold" />}
              onClick={exportButton}
            />
          }
          {visibleButton && (
            <S.ContentPopButton>
              <ActionButton
                name="Novo Cadastro"
                Icon={<CaretDown size={16} weight="fill" />}
                onClick={() => toggleModalVisibility("menu")}
              />
              {isOpenModal("menu") && (
                <div ref={(ref) => assignRef("menu", ref)}>
                  <PopMenu
                    listName={listPopMenu}
                    onClickHandlers={listPopButton?.map((val) => {
                      return () => toggleModalVisibility(val);
                    })}
                  />
                </div>
              )}
            </S.ContentPopButton>
          )}
        </S.ContentButton>
      </S.ContentSearch>

      <Create
        isOpenModal={isOpenModal("create")}
        setModalClose={() => toggleModalVisibility("create")}
        refreshFrames={fetchData}
      />
      <CreateSupplier
        isOpenModal={isOpenModal("supplier")}
        setModalClose={() => toggleModalVisibility("supplier")}
        refreshFrames={fetchData}
      />
      <CreateBrainds
        isOpenModalBraind={isOpenModal("brainds")}
        setModalClose={() => toggleModalVisibility("brainds")}
        refreshFrames={fetchData}
      />
      <CreateMaterial
        isOpenModalMaterial={isOpenModal("material")}
        setModalClose={() => toggleModalVisibility("material")}
        refreshFrames={fetchData}
      />
      <CreateLens
        isOpenModalLens={isOpenModal("lens")}
        setModalClose={() => toggleModalVisibility("lens")}
        refreshData={fetchData}
      />
      <CreateAntiGlare
        isOpenModalBraind={isOpenModal("anti-glare")}
        setModalClose={() => toggleModalVisibility("anti-glare")}
        refreshData={fetchData}
      />
      <CreateTypeLens
        isOpenModalBraind={isOpenModal("type-lens")}
        setModalClose={() => toggleModalVisibility("type-lens")}
        refreshFrames={fetchData}
      />
      <CreateSensitivity
        isOpenModalBraind={isOpenModal("sensitivity")}
        setModalClose={() => toggleModalVisibility("sensitivity")}
        refreshFrames={fetchData}
      />
      <CreateLaboratory
        isOpenModalBraind={isOpenModal("laboratory")}
        setModalClose={() => toggleModalVisibility("laboratory")}
        refreshData={fetchData}
      />
      <CreateCustomer
        isOpenModalCustomer={isOpenModal("customer")}
        setModalClose={() => toggleModalVisibility("customer")}
        refreshFrames={fetchData}
      />
      <CreateAgreements
        isOpenModalMaterial={isOpenModal("agreement")}
        setModalClose={() => toggleModalVisibility("agreement")}
        refreshFrames={fetchData}
      />
      <CreateExpenses
        isOpenModal={isOpenModal("expense")}
        setModalClose={() => toggleModalVisibility("expense")}
        refreshFrames={fetchData}
      />
      <CreateCategory
        isOpenModal={isOpenModal("category-expense")}
        setModalClose={() => toggleModalVisibility("category-expense")}
        refreshFrames={fetchData}
      />
      <CreateSurfacing
        isOpenModal={isOpenModal("surfacing")}
        setModalClose={() => toggleModalVisibility("surfacing")}
        refreshFrames={fetchData}
      />
      <CreateDiameter
        isOpenModal={isOpenModal("diameter")}
        setModalClose={() => toggleModalVisibility("diameter")}
        refreshFrames={fetchData}
      />
      <CreateIndice
        isOpenModal={isOpenModal("index")}
        setModalClose={() => toggleModalVisibility("index")}
        refreshFrames={fetchData}
      />
      <CreateHeight
        isOpenModal={isOpenModal("height")}
        setModalClose={() => toggleModalVisibility("height")}
        refreshFrames={fetchData}
      />
      {/* <LayoutWithListRegister
        isOpenModal={isOpenModal("index")}
        setModalClose={() => toggleModalVisibility("index")}
        
        title="Registrar Índice"
        subTitle="Cadastre um novo índice em sua base de dados."
        
        label="índice"
        placeholer="Infome o índice"
        typeInput="number"
        
        apiSubmit='index'
        registerIput = 'index'
        refreshFrames={fetchData}
      /> */}
    </S.Container>
  );
}
